import produce from "immer";
import IDeliveriesReducer from "models/IDeliveriesReducer";
import { actionTypes } from "./actions";
import { deliveriesSorting as defaultSorting } from "constants/sorting";

const initialState: IDeliveriesReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  deliveryLines: [],
  fustLines: [],
  costLines: [],
  meta: {
    defaultSorting
  },
  currentItem: null,
  error: null
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_DELIVERIES_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_DELIVERIES_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_DELIVERY_REQUEST:
        draftState.currentItem = null;
        break;
      case actionTypes.GET_DELIVERY_SUCCESS:
        draftState.currentItem = action.payload;
        break;
      case actionTypes.GET_DELIVERY_FAILURE:
        return {
          ...initialState,
          error: action.error
        };
      case actionTypes.GET_DELIVERY_LINES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_DELIVERY_LINES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.deliveryLines = action.payload;
        break;
      case actionTypes.GET_DELIVERY_LINES_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_FUST_LINES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_FUST_LINES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.fustLines = action.payload;
        break;
      case actionTypes.GET_FUST_LINES_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_COST_LINES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_COST_LINES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.costLines = action.payload;
        break;
      case actionTypes.GET_COST_LINES_FAILURE:
        draftState.error = action.error;
        break;
    }
  });
